import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    title: {
      display: 'flex',
    },
    justified: {
      justifyContent: 'space-between',
    },
    centered: {
      justifyContent: 'center',
      fontSize: '14px'
    },
    subtitle: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: theme.spacing(1),
    },
  })
);
